import { getElement, getElements, ifSelectorExist } from './utils';

export const reviewRate = () => {
    const rateStars = getElements('.star.rating');
    const reviewRateMainWrapper = getElement('.reviews_rate__wrapper');
    const reviewRateResourcesWrapper = getElements('.reviews_rate__resources_wrapper');

    const [formWrapper, googleWrapper, facebookWrapper] = reviewRateResourcesWrapper;

    const showElement = (elementToShow, elementToHide) => {
        elementToShow.classList.add('show');
        elementToHide.classList.add('hide');
    };

    const hideElement = (elementToHide, elementToShow) => {
        elementToHide.classList.remove('show');
        elementToShow.classList.remove('hide');
    };

    const setupReviewRateGoogle = () => {
        const reviewRateGoogleNoButton = getElement('.reviews_rate__resources_wrapper.google .no-button');
        const reviewRateGoogleGoBackButton = getElement('.reviews_rate__resources_wrapper.google .go-back-button');

        if (ifSelectorExist(reviewRateGoogleNoButton) && ifSelectorExist(reviewRateGoogleGoBackButton)) {
            reviewRateGoogleNoButton.addEventListener('click', () => {
                showElement(facebookWrapper, googleWrapper);
                hideElement(googleWrapper);
            });
    
            if (ifSelectorExist(reviewRateGoogleGoBackButton)) {
                reviewRateGoogleGoBackButton.addEventListener('click', () => {
                    hideElement(googleWrapper, reviewRateMainWrapper);
                });   
            }
        }
    };

    const setupReviewRateFacebook = () => {
        const reviewRateFacebookNoButton = getElement('.reviews_rate__resources_wrapper.facebook .no-button');
        const reviewRateFaceBookGoBackButton = getElement('.reviews_rate__resources_wrapper.facebook .go-back-button');

        if (ifSelectorExist(reviewRateFacebookNoButton) && ifSelectorExist(reviewRateFaceBookGoBackButton)) {
            reviewRateFacebookNoButton.addEventListener('click', () => {
                showElement(formWrapper, facebookWrapper);
                hideElement(facebookWrapper);
            });
    
            if (ifSelectorExist(reviewRateFaceBookGoBackButton)) {
                reviewRateFaceBookGoBackButton.addEventListener('click', () => {
                    hideElement(facebookWrapper, googleWrapper);
                    showElement(googleWrapper);
                });      
            }
        }
    };

    const goOver = () => {
        const reviewRateGoogleNoForm = getElement('.reviews_rate__resources_wrapper.form .go-over-button');
        if (ifSelectorExist(reviewRateGoogleNoForm)) {
            reviewRateGoogleNoForm.addEventListener('click', () => {
                hideElement(formWrapper, reviewRateMainWrapper);
                showElement(reviewRateMainWrapper);
            });   
        }
    }

    if (ifSelectorExist(rateStars)) {
        rateStars.forEach((star, index) => {
            star.addEventListener('click', () => {
                if (index < 4) {
                    // Form
                    showElement(formWrapper, reviewRateMainWrapper);
    
                    // Go Over
                    goOver();
                } else {
                    // Google
                    showElement(googleWrapper, reviewRateMainWrapper);
                    setupReviewRateGoogle();
    
                    // FaceBook
                    setupReviewRateFacebook();
                    
                    // Go Over
                    goOver();
                }
            });
        });   
    }
};